import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IBrokerParams } from 'global.interfaces';

export const useSupportEmail = (brokerParams: IBrokerParams) => {
  const { i18n } = useTranslation();

  const getClientSupportEmail = useCallback(() => {
    const lang = i18n.language;

    if (lang in brokerParams) {
      return brokerParams[lang].clientSupportEmail;
    }
  }, [brokerParams, i18n.language]);

  const getTechnicalSupportEmail = useCallback(() => {
    const lang = i18n.language;

    if (lang in brokerParams) {
      return brokerParams[lang].technicalSupportEmail;
    }
  }, [brokerParams, i18n.language]);

  const supportEmails = useMemo(
    () => ({
      clientSupportEmail: getClientSupportEmail(),
      technicalSupportEmail: getTechnicalSupportEmail(),
    }),
    [getClientSupportEmail, getTechnicalSupportEmail],
  );

  return supportEmails;
};
